export default __webpack_public_path__ + "static/media/phone.390cfd72.svg";